<template>
  <ul class="sidebar" v-if="!$route.meta.ignoreSideBar && !isAdSite">
    <li class="item">
      <UiIcon type="IconEarPhone" :size="28"></UiIcon>
      <span>客服</span>
      <div class="wechat">
        <img :src="formatImage(imgPrefix + 'wechat-service_20240801.jpg', 300)" alt="" />
      </div>
    </li>
    <li class="item" @click="onGoFeedBack">
      <UiIcon type="IconEdit1" :size="28"></UiIcon>
      <span>反馈</span>
    </li>
  </ul>
</template>

<script>
import { formatImage } from '@/utils/file'
import { isAdSite } from '@/utils/ua'

export default {
  data() {
    return {
      isAdSite
    }
  },
  methods: {
    formatImage,
    onGoFeedBack() {
      window.open('https://jsj.top/f/iMc1s4')
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  border-radius: 8px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: fixed;
  right: 10px;
  bottom: 30px;
  padding: 10px 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    color: #292929;
    position: relative;
    transition: 0.3s all;
    &:hover {
      color: #54a5ff;
      cursor: pointer;
      .wechat {
        opacity: 1;
      }
      svg {
        fill: #54a5ff;
      }
    }
    .wechat {
      position: absolute;
      right: 44px;
      bottom: 0px;
      border-radius: 6px;
      padding: 10px;
      background: #fff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      transition: 0.3s all;
      opacity: 0;
      pointer-events: none;
      img {
        height: 300px;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .sidebar {
    display: none;
  }
}
</style>
